var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKababBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_179735",
    "data-name": "Group 179735",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.956,
    height: 12,
    viewBox: "0 0 2.956 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_110",
    "data-name": "Union 110",
    d: "M0,10.521A1.478,1.478,0,1,1,1.479,12,1.479,1.479,0,0,1,0,10.521ZM0,6A1.476,1.476,0,1,1,1.476,7.478,1.477,1.477,0,0,1,0,6ZM0,1.479A1.476,1.476,0,1,1,1.476,2.956,1.477,1.477,0,0,1,0,1.479Z",
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKababBlue);
export default __webpack_public_path__ + "static/media/kababBlue.a4221bf3e4db9f606094c4853aa52d7e.svg";
export { ForwardRef as ReactComponent };